module.exports = __webpack_public_path__ + "media/application/images/2023/07_still-1600x900-98b24d2c37e52eb2bb386a08ed805c34.png";